/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListBookingData } from './genericApiResponseListBookingData';
import type { GenericApiResponseListBookingMessage } from './genericApiResponseListBookingMessage';
import type { GenericApiResponseListBookingPagination } from './genericApiResponseListBookingPagination';
import type { GenericApiResponseListBookingError } from './genericApiResponseListBookingError';

export interface GenericApiResponseListBooking {
  data?: GenericApiResponseListBookingData;
  message?: GenericApiResponseListBookingMessage;
  pagination?: GenericApiResponseListBookingPagination;
  error?: GenericApiResponseListBookingError;
  statusCode?: number;
}
